var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    _vm._b(
      {
        ref: "sonFormData",
        staticClass: "dg-form",
        attrs: {
          id: "DgForm",
          inline: _vm.inline,
          model: _vm.sonFormData,
          rules: _vm.rules,
          "label-width": _vm.labelWidth,
          "label-position": _vm.labelPosition,
        },
        nativeOn: {
          submit: function ($event) {
            $event.preventDefault()
          },
        },
      },
      "el-form",
      _vm.$attrs,
      false
    ),
    [
      _vm.resetForm
        ? _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  staticStyle: { float: "right" },
                  on: {
                    click: function ($event) {
                      return _vm.handleResetForm("sonFormData")
                    },
                  },
                },
                [_vm._v("重置")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.formItems, function (item, index) {
        var arguments$1 = arguments
        return [
          item.editer === "text"
            ? _c("div", {
                key: index,
                style: item.style,
                domProps: { innerHTML: _vm._s(item.content) },
              })
            : _vm._e(),
          _vm._v(" "),
          item.editer === "formText"
            ? _c(
                "el-form-item",
                {
                  key: index + item.value,
                  staticClass: "textInput",
                  style: item.formItemStyle,
                  attrs: { label: item.label, prop: item.value },
                },
                [
                  item.explain
                    ? _c(
                        "template",
                        { slot: "label" },
                        [
                          _vm._v(_vm._s(item.label) + "\n        "),
                          _c(
                            "dg-tooltip",
                            {
                              attrs: {
                                effect: item.explain.dark,
                                "api-code": item.explain.apiCode,
                                "primary-key": item.explain.primaryKey,
                                content: item.explain.content,
                                placement: item.explain.placement,
                              },
                            },
                            [_c("i", { staticClass: "el-icon-question" })]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      key: index,
                      style: item.style,
                      attrs: {
                        title: item.content || _vm.sonFormData[item.value],
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(item.content || _vm.sonFormData[item.value]) +
                          "\n      "
                      ),
                    ]
                  ),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          item.editer === "input" && !item.autoShow
            ? _c(
                "el-form-item",
                {
                  key: index + item.value,
                  staticClass: "textInput",
                  style: item.formItemStyle,
                  attrs: { label: item.label, prop: item.value },
                },
                [
                  item.explain
                    ? _c(
                        "template",
                        { slot: "label" },
                        [
                          _vm._v(_vm._s(item.label) + "\n        "),
                          _c(
                            "dg-tooltip",
                            {
                              attrs: {
                                effect: item.explain.dark,
                                "api-code": item.explain.apiCode,
                                "primary-key": item.explain.primaryKey,
                                content: item.explain.content,
                                placement: item.explain.placement,
                              },
                            },
                            [_c("i", { staticClass: "el-icon-question" })]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  item.type === "password"
                    ? _c(
                        "el-input",
                        {
                          directives: [
                            {
                              name: "cleaveEl",
                              rawName: "v-cleaveEl",
                              value: item.cleave || { notCleave: true },
                              expression: "item.cleave || { notCleave: true }",
                            },
                          ],
                          ref: item.ref,
                          refInFor: true,
                          style: item.style,
                          attrs: {
                            type: item.type,
                            size: item.size || "mini",
                            maxlength: item.maxlength,
                            autosize: {
                              minRows: item.minRows,
                              maxRows: item.maxRows,
                            },
                            "prefix-icon": item.prefixIcon,
                            "suffix-icon": item.suffixIcon,
                            readonly: item.readonly,
                            placeholder:
                              item.placeholder ||
                              (item.disabled ? "" : "请输入"),
                            disabled: item.disabled,
                            "show-password": item.showPassword,
                          },
                          on: {
                            input: function (value) {
                              _vm.handleEventInput(value, item)
                            },
                            focus: function ($event) {
                              return _vm.handleEvent(item)
                            },
                            blur: function ($event) {
                              return _vm.handleEventBlur(item)
                            },
                          },
                          nativeOn: {
                            "!paste": function ($event) {
                              $event.preventDefault()
                              return function () {}.apply(null, arguments)
                            },
                            "!copy": function ($event) {
                              $event.preventDefault()
                              return function () {}.apply(null, arguments)
                            },
                            "!cut": function ($event) {
                              $event.preventDefault()
                              return function () {}.apply(null, arguments)
                            },
                            click: function ($event) {
                              return _vm.clickEvent(item)
                            },
                          },
                          model: {
                            value: _vm.sonFormData[item.value],
                            callback: function ($$v) {
                              _vm.$set(_vm.sonFormData, item.value, $$v)
                            },
                            expression: "sonFormData[item.value]",
                          },
                        },
                        [
                          item.prepend
                            ? _c("template", { slot: "prepend" }, [
                                _c("span", [_vm._v(_vm._s(item.prepend))]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          item.append
                            ? _c("template", { slot: "append" }, [
                                _c("span", [_vm._v(_vm._s(item.append))]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          item.myAppend
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    slot: "append",
                                    icon: "el-icon-search",
                                    disabled: item.disabled,
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      return item.appendClick.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                  slot: "append",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      item.appendLable
                                        ? item.appendLable
                                        : "查询"
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          item.myAppendButton
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    slot: "append",
                                    icon: item.appendIcon,
                                    disabled: item.appendDisabled,
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      return item.appendClick.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                  slot: "append",
                                },
                                [_vm._v(_vm._s(item.appendLable))]
                              )
                            : _vm._e(),
                        ],
                        2
                      )
                    : _c(
                        "el-input",
                        {
                          directives: [
                            {
                              name: "cleaveEl",
                              rawName: "v-cleaveEl",
                              value: item.cleave || { notCleave: true },
                              expression: "item.cleave || { notCleave: true }",
                            },
                          ],
                          ref: item.ref,
                          refInFor: true,
                          style: item.style,
                          attrs: {
                            type: item.type,
                            size: item.size || "mini",
                            maxlength: item.maxlength,
                            autosize: {
                              minRows: item.minRows,
                              maxRows: item.maxRows,
                            },
                            "prefix-icon": item.prefixIcon,
                            "suffix-icon": item.suffixIcon,
                            readonly: item.readonly,
                            placeholder:
                              item.placeholder ||
                              (item.disabled ? "" : "请输入"),
                            disabled: item.disabled,
                            "show-password": item.showPassword,
                          },
                          on: {
                            input: function (value) {
                              _vm.handleEventInput(value, item)
                            },
                            focus: function ($event) {
                              return _vm.handleEvent(item)
                            },
                            blur: function ($event) {
                              return _vm.handleEventBlur(item)
                            },
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.clickEvent(item)
                            },
                          },
                          model: {
                            value: _vm.sonFormData[item.value],
                            callback: function ($$v) {
                              _vm.$set(_vm.sonFormData, item.value, $$v)
                            },
                            expression: "sonFormData[item.value]",
                          },
                        },
                        [
                          item.prepend
                            ? _c("template", { slot: "prepend" }, [
                                _c("span", [_vm._v(_vm._s(item.prepend))]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          item.append
                            ? _c("template", { slot: "append" }, [
                                _c("span", [_vm._v(_vm._s(item.append))]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          item.myAppend
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    slot: "append",
                                    icon: "el-icon-search",
                                    disabled: item.disabled,
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      return item.appendClick.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                  slot: "append",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      item.appendLable
                                        ? item.appendLable
                                        : "查询"
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          item.myAppendButton
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    slot: "append",
                                    icon: item.appendIcon,
                                    disabled: item.appendDisabled,
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      return item.appendClick.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                  slot: "append",
                                },
                                [_vm._v(_vm._s(item.appendLable))]
                              )
                            : _vm._e(),
                        ],
                        2
                      ),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          item.editer === "autocomplete" && !item.autoShow
            ? _c(
                "el-form-item",
                {
                  key: index + item.value,
                  style: item.formItemStyle,
                  attrs: { label: item.label, prop: item.value },
                },
                [
                  item.explain
                    ? _c(
                        "template",
                        { slot: "label" },
                        [
                          _vm._v(_vm._s(item.label) + "\n        "),
                          _c(
                            "dg-tooltip",
                            {
                              attrs: {
                                effect: item.explain.dark,
                                "api-code": item.explain.apiCode,
                                "primary-key": item.explain.primaryKey,
                                content: item.explain.content,
                                placement: item.explain.placement,
                              },
                            },
                            [_c("i", { staticClass: "el-icon-question" })]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-autocomplete", {
                    style: item.style,
                    attrs: {
                      size: item.size || "mini",
                      placeholder:
                        item.placeholder || (item.disabled ? "" : "请输入"),
                      clearable: item.clearable,
                      readonly: item.readonly,
                      disabled: item.disabled,
                      "fetch-suggestions": function (queryString, cb) {
                        _vm.autoQuerySearch(queryString, cb, item)
                      },
                    },
                    on: {
                      select: function (selItem) {
                        _vm.autoHandleSelect(selItem, item)
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c("div", [
                                _vm._v("\n            " + _vm._s(item.title)),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "font-size": "12px",
                                      color: "rgba(144, 147, 152, 1)",
                                      float: "right",
                                    },
                                  },
                                  [_vm._v(_vm._s(item.value))]
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                    model: {
                      value: _vm.sonFormData[item.value],
                      callback: function ($$v) {
                        _vm.$set(_vm.sonFormData, item.value, $$v)
                      },
                      expression: "sonFormData[item.value]",
                    },
                  }),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          item.editer === "autocomplete1" && !item.autoShow
            ? _c(
                "el-form-item",
                {
                  key: index + item.value,
                  style: item.formItemStyle,
                  attrs: { label: item.label, prop: item.value },
                },
                [
                  _c("el-autocomplete", {
                    style: item.style,
                    attrs: {
                      size: item.size || "mini",
                      placeholder:
                        item.placeholder || (item.disabled ? "" : "请输入"),
                      disabled: item.disabled,
                      "fetch-suggestions": item.querySearchAsync,
                    },
                    on: { select: item.selectChange },
                    model: {
                      value: _vm.sonFormData[item.value],
                      callback: function ($$v) {
                        _vm.$set(_vm.sonFormData, item.value, $$v)
                      },
                      expression: "sonFormData[item.value]",
                    },
                  }),
                ],
                1
              )
            : item.editer === "select" && !item.autoShow
            ? _c(
                "el-form-item",
                {
                  key: index + item.value,
                  ref: "selectSpecil",
                  refInFor: true,
                  staticClass: "selectSpecil",
                  style: item.formItemStyle,
                  attrs: { label: item.label, prop: item.value },
                },
                [
                  item.explain
                    ? _c(
                        "template",
                        { slot: "label" },
                        [
                          _vm._v(_vm._s(item.label) + "\n        "),
                          _c(
                            "dg-tooltip",
                            {
                              attrs: {
                                effect: item.explain.dark,
                                "api-code": item.explain.apiCode,
                                "primary-key": item.explain.primaryKey,
                                content: item.explain.content,
                                placement: item.explain.placement,
                              },
                            },
                            [_c("i", { staticClass: "el-icon-question" })]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("dg-select", {
                    ref: item.ref,
                    refInFor: true,
                    attrs: {
                      disabled: item.disabled,
                      clearable: item.clearable,
                      multiple: item.multiple,
                      size: item.size || "mini",
                      "dg-style": item.style,
                      "no-cache": item.noCache,
                      name: _vm.sonFormData[item.selectNameKey],
                      "value-format": item.valueFormat || "",
                      "dim-code": item.dimCode,
                      "code-type": item.codeType,
                      "api-code": item.apiCode,
                      "file-type": item.fileType,
                      "filter-val": item.filterVal,
                      "collapse-tags": item.collapseTags,
                      "filter-limit": item.filterLimit,
                      "query-terms": item.queryTerms,
                      default: item.default,
                      "select-options": item.selectOptions,
                      "select-str": item.selectStr,
                      placeholder: item.placeholder,
                      allowCreate: item.allowCreate,
                    },
                    on: {
                      "update:name": function ($event) {
                        item.selectNameKey
                          ? (_vm.sonFormData[item.selectNameKey] = $event)
                          : ""
                      },
                      change: function (value, index, OPTIONS_LENGTH, flag) {
                        return _vm.handleEvent(arguments$1, item, flag)
                      },
                    },
                    model: {
                      value: _vm.sonFormData[item.value],
                      callback: function ($$v) {
                        _vm.$set(_vm.sonFormData, item.value, $$v)
                      },
                      expression: "sonFormData[item.value]",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { domProps: { innerHTML: _vm._s(_vm.helpInfo) } }),
                ],
                2
              )
            : item.editer === "inputNumber" && !item.autoShow
            ? _c(
                "el-form-item",
                {
                  key: index + item.value,
                  style: item.formItemStyle,
                  attrs: { label: item.label, prop: item.value },
                },
                [
                  _c("el-input-number", {
                    style: item.style,
                    attrs: {
                      placeholder: item.placeholder,
                      size: item.size || "mini",
                      step: item.step,
                      min: item.min,
                      max: item.max,
                      disabled: item.disabled,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.handleEvent(item)
                      },
                    },
                    model: {
                      value: _vm.sonFormData[item.value],
                      callback: function ($$v) {
                        _vm.$set(_vm.sonFormData, item.value, $$v)
                      },
                      expression: "sonFormData[item.value]",
                    },
                  }),
                ],
                1
              )
            : item.editer === "textarea" && !item.autoShow
            ? _c(
                "el-form-item",
                {
                  key: index + item.value,
                  staticClass: "textInput",
                  style: item.formItemStyle,
                  attrs: { label: item.label, prop: item.value },
                },
                [
                  item.explain
                    ? _c(
                        "template",
                        { slot: "label" },
                        [
                          _vm._v(_vm._s(item.label) + "\n        "),
                          _c(
                            "dg-tooltip",
                            {
                              attrs: {
                                effect: item.explain.dark,
                                "api-code": item.explain.apiCode,
                                "primary-key": item.explain.primaryKey,
                                content: item.explain.content,
                                placement: item.explain.placement,
                              },
                            },
                            [_c("i", { staticClass: "el-icon-question" })]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  item.value === "paraval" ? _vm._t("default") : _vm._e(),
                  _vm._v(" "),
                  _c("el-input", {
                    style: item.style,
                    attrs: {
                      type: "textarea",
                      readonly: item.readonly,
                      maxlength: item.maxlength,
                      rows: item.rows || 4,
                      disabled: item.disabled,
                      placeholder:
                        item.placeholder || (item.disabled ? "" : "请输入"),
                    },
                    model: {
                      value: _vm.sonFormData[item.value],
                      callback: function ($$v) {
                        _vm.$set(_vm.sonFormData, item.value, $$v)
                      },
                      expression: "sonFormData[item.value]",
                    },
                  }),
                ],
                2
              )
            : item.editer === "rate"
            ? _c(
                "el-form-item",
                {
                  key: index + item.value,
                  style: item.formItemStyle,
                  attrs: { label: item.label, prop: item.value },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        height: "32px",
                        "align-items": "center",
                      },
                    },
                    [
                      _c("el-rate", {
                        attrs: {
                          colors: item.colors,
                          "show-score": item.showScore,
                          "show-text": item.showText,
                          "text-color": item.textColor,
                          max: item.max,
                          disabled: item.disabled,
                        },
                        model: {
                          value: _vm.sonFormData[item.value],
                          callback: function ($$v) {
                            _vm.$set(_vm.sonFormData, item.value, $$v)
                          },
                          expression: "sonFormData[item.value]",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              )
            : item.editer === "switch" && !item.autoShow
            ? _c(
                "el-form-item",
                {
                  key: index + item.value,
                  style: item.formItemStyle,
                  attrs: { label: item.label, prop: item.value },
                },
                [
                  item.explain
                    ? _c(
                        "template",
                        { slot: "label" },
                        [
                          _vm._v(_vm._s(item.label) + "\n        "),
                          _c(
                            "dg-tooltip",
                            {
                              attrs: {
                                effect: item.explain.dark,
                                "api-code": item.explain.apiCode,
                                "primary-key": item.explain.primaryKey,
                                content: item.explain.content,
                                placement: item.explain.placement,
                              },
                            },
                            [_c("i", { staticClass: "el-icon-question" })]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-switch", {
                    style: item.style,
                    attrs: {
                      disabled: item.disabled,
                      size: item.size || "mini",
                      "active-text": item.activeText,
                      "inactive-text": item.inactiveText,
                      "active-value": item.activeValue,
                      "inactive-value": item.inactiveValue,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.handleEvent(item)
                      },
                    },
                    model: {
                      value: _vm.sonFormData[item.value],
                      callback: function ($$v) {
                        _vm.$set(_vm.sonFormData, item.value, $$v)
                      },
                      expression: "sonFormData[item.value]",
                    },
                  }),
                ],
                2
              )
            : item.editer === "radio" && !item.autoShow
            ? _c(
                "el-form-item",
                {
                  key: index + item.value,
                  style: item.formItemStyle,
                  attrs: { label: item.label, prop: item.value },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      style: item.style,
                      attrs: {
                        size: item.size || "mini",
                        disabled: item.disabled,
                      },
                      on: {
                        change: function ($event) {
                          return _vm.handleEvent(item)
                        },
                      },
                      model: {
                        value: _vm.sonFormData[item.value],
                        callback: function ($$v) {
                          _vm.$set(_vm.sonFormData, item.value, $$v)
                        },
                        expression: "sonFormData[item.value]",
                      },
                    },
                    [
                      _vm._l(item.options, function (option, index) {
                        return [
                          _c(
                            "el-radio",
                            {
                              key: option.value,
                              attrs: {
                                border: option.border,
                                disabled: option.disabled,
                                label: option.value,
                              },
                            },
                            [_vm._v(_vm._s(option.name))]
                          ),
                        ]
                      }),
                    ],
                    2
                  ),
                ],
                1
              )
            : item.editer === "radioButton" && !item.autoShow
            ? _c(
                "el-form-item",
                {
                  key: index + item.value,
                  style: item.formItemStyle,
                  attrs: { label: item.label, prop: item.value },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      style: item.style,
                      attrs: {
                        size: item.size || "mini",
                        disabled: item.disabled,
                      },
                      on: {
                        change: function ($event) {
                          return _vm.handleEvent(item)
                        },
                      },
                      model: {
                        value: _vm.sonFormData[item.value],
                        callback: function ($$v) {
                          _vm.$set(_vm.sonFormData, item.value, $$v)
                        },
                        expression: "sonFormData[item.value]",
                      },
                    },
                    [
                      _vm._l(item.options, function (option, index) {
                        return [
                          _c(
                            "el-radio-button",
                            {
                              key: option.value,
                              attrs: {
                                border: option.border,
                                disabled: option.disabled,
                                label: option.value,
                              },
                            },
                            [
                              _c("span", { class: option.class }, [
                                _vm._v(_vm._s(option.name)),
                              ]),
                            ]
                          ),
                        ]
                      }),
                    ],
                    2
                  ),
                ],
                1
              )
            : item.editer === "check" && !item.autoShow
            ? _c(
                "el-form-item",
                {
                  key: index + item.value,
                  style: item.formItemStyle,
                  attrs: { label: item.label, prop: item.value },
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      attrs: { disabled: item.disable },
                      on: {
                        change: function ($event) {
                          return _vm.handleEvent(item)
                        },
                      },
                      model: {
                        value: _vm.sonFormData[item.value],
                        callback: function ($$v) {
                          _vm.$set(_vm.sonFormData, item.value, $$v)
                        },
                        expression: "sonFormData[item.value]",
                      },
                    },
                    [_vm._v(_vm._s(item.name))]
                  ),
                ],
                1
              )
            : item.editer === "checkbox" && !item.autoShow
            ? _c(
                "el-form-item",
                {
                  key: index + item.value,
                  style: item.formItemStyle,
                  attrs: { label: item.label, prop: item.value },
                },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      style: item.style,
                      attrs: { min: item.min, max: item.max },
                      on: {
                        change: function ($event) {
                          return _vm.handleEvent(item)
                        },
                      },
                      model: {
                        value: _vm.sonFormData[item.value],
                        callback: function ($$v) {
                          _vm.$set(_vm.sonFormData, item.value, $$v)
                        },
                        expression: "sonFormData[item.value]",
                      },
                    },
                    [
                      _vm._l(item.options, function (option, index) {
                        return [
                          _c(
                            "el-checkbox",
                            {
                              key: option.value,
                              attrs: {
                                border: option.border,
                                disabled: option.disable,
                                label: option.value,
                              },
                            },
                            [_vm._v(_vm._s(option.name))]
                          ),
                        ]
                      }),
                    ],
                    2
                  ),
                ],
                1
              )
            : item.editer === "checkboxButton" && !item.autoShow
            ? _c(
                "el-form-item",
                {
                  key: index + item.value,
                  style: item.formItemStyle,
                  attrs: { label: item.label, prop: item.value },
                },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      style: item.style,
                      on: {
                        change: function ($event) {
                          return _vm.handleEvent(item)
                        },
                      },
                      model: {
                        value: _vm.sonFormData[item.value],
                        callback: function ($$v) {
                          _vm.$set(_vm.sonFormData, item.value, $$v)
                        },
                        expression: "sonFormData[item.value]",
                      },
                    },
                    [
                      _vm._l(item.options, function (option, index) {
                        return [
                          _c(
                            "el-checkbox-button",
                            {
                              key: option.value,
                              attrs: {
                                border: option.border,
                                disabled: option.disable,
                                label: option.value,
                              },
                            },
                            [_vm._v(_vm._s(option.name))]
                          ),
                        ]
                      }),
                    ],
                    2
                  ),
                ],
                1
              )
            : item.editer === "timePicker" && !item.autoShow
            ? _c(
                "el-form-item",
                {
                  key: index + item.value,
                  style: item.formItemStyle,
                  attrs: { label: item.label, prop: item.value },
                },
                [
                  _c("el-time-picker", {
                    style: item.style,
                    attrs: {
                      size: item.size || "mini",
                      "is-range": item.isRange,
                      disabled: item.disabled,
                      "value-format": item.valueFormat,
                      "default-value": item.defaultValue,
                      "picker-options": item.pickerOptions,
                      "range-separator": item.rangeSeparator || "至",
                      "start-placeholder":
                        item.startPlaceholder ||
                        (item.disabled ? "" : "开始时间"),
                      "end-placeholder":
                        item.endPlaceholder ||
                        (item.disabled ? "" : "结束时间"),
                      placeholder:
                        item.placeholder || (item.disabled ? "" : "请选择时间"),
                    },
                    on: {
                      change: function ($event) {
                        return _vm.handleEvent(item)
                      },
                    },
                    model: {
                      value: _vm.sonFormData[item.value],
                      callback: function ($$v) {
                        _vm.$set(_vm.sonFormData, item.value, $$v)
                      },
                      expression: "sonFormData[item.value]",
                    },
                  }),
                ],
                1
              )
            : item.editer === "datePicker" && !item.autoShow
            ? _c(
                "el-form-item",
                {
                  key: index + item.value,
                  style: item.formItemStyle,
                  attrs: { label: item.label, prop: item.value },
                },
                [
                  _c("el-date-picker", {
                    style: item.style,
                    attrs: {
                      size: item.size || "mini",
                      type: item.type || "date",
                      disabled: item.disabled,
                      readonly: item.readonly,
                      format: item.format || "yyyy-MM-dd",
                      "value-format": item.valueFormat || "yyyy-MM-dd",
                      clearable: item.clearable || false,
                      placeholder: item.placeholder || "选择日期",
                      "range-separator": item.rangeSeparator || "至",
                      "default-time":
                        item.type && item.type.indexOf("range") > -1
                          ? item.defaultTime || ["00:00:00", "23:59:59"]
                          : "",
                      "start-placeholder": item.startPlaceholder || "开始日期",
                      "end-placeholder": item.endPlaceholder || "结束日期",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.handleEvent(item)
                      },
                    },
                    model: {
                      value: _vm.sonFormData[item.value],
                      callback: function ($$v) {
                        _vm.$set(_vm.sonFormData, item.value, $$v)
                      },
                      expression: "sonFormData[item.value]",
                    },
                  }),
                ],
                1
              )
            : item.editer === "fileUpload" && !item.autoShow
            ? _c(
                "el-form-item",
                {
                  key: index,
                  style: item.formItemStyle,
                  attrs: { label: item.label, prop: item.value },
                },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c(
                        "el-upload",
                        {
                          ref: "upload",
                          refInFor: true,
                          class: item.class,
                          staticStyle: {
                            "margin-right": "10px",
                            "min-width": "30%",
                          },
                          attrs: {
                            action: item.action || "",
                            "http-request": function (param) {
                              return _vm.httpRequest(param, item)
                            },
                            limit: item.limit || 1,
                            "on-exceed": _vm.handleExceed,
                            "on-preview": item.handlePreview,
                            disabled: item.disabled,
                            "on-remove": item.handleRemove || _vm.handleRemove,
                            "file-list": item.fileList || [],
                            "on-change": item.handleChange,
                            "on-success": item.handleSuccess,
                            "on-error": item.handleError,
                            "before-upload": item.beforeUpload,
                            "before-remove": item.beforeRemove,
                            "auto-upload":
                              item.autoUpload === false ? false : true,
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "btn-block",
                              attrs: {
                                disabled: item.disabled,
                                size: "mini",
                                type: "primary",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.submitUpload(item)
                                },
                              },
                            },
                            [_vm._v("点击上传\n          ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "el-upload__tip",
                              attrs: { slot: "tip" },
                              slot: "tip",
                            },
                            [_vm._v(_vm._s(item.tip))]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _vm._l(item.moreOptions, function (action, index) {
                            return [
                              _c(
                                "el-button",
                                {
                                  key: index,
                                  style: action.style,
                                  attrs: {
                                    title: action.tooltip,
                                    type: action.type || "primary",
                                    size: action.size || "mini",
                                    plain: action.plain,
                                    round: action.round,
                                    circle: action.circle,
                                    icon: action.icon,
                                    disabled: action.disabled,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.clickUploadOptions(
                                        action,
                                        item
                                      )
                                    },
                                  },
                                },
                                [
                                  action.title
                                    ? _c("span", [_vm._v(_vm._s(action.title))])
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ]
              )
            : item.editer === "knowledgeBaseSelect" && !item.autoShow
            ? _c(
                "el-form-item",
                {
                  key: index,
                  style: item.formItemStyle,
                  attrs: { label: item.label, prop: item.value },
                },
                [
                  _c("dg-knowledge-base-select", {
                    ref: "knowledgeBaseSelect",
                    refInFor: true,
                    attrs: { "form-item": item },
                  }),
                ],
                1
              )
            : (item.editer === "button" ||
                item.editer === "add" ||
                item.editer === "search") &&
              !item.autoShow
            ? _c(
                "el-form-item",
                {
                  key: index,
                  class: item.editer === "add" ? "add-formItem-class" : "",
                  style: item.formItemStyle,
                  attrs: { label: item.label, prop: item.value },
                },
                [
                  item.editer === "search"
                    ? _c(
                        "el-button",
                        {
                          style: item.style,
                          attrs: {
                            title: item.tooltip,
                            type: item.type || "info",
                            size: item.size || "mini",
                            plain: item.plain === false ? false : true,
                            round: item.round,
                            circle: item.circle,
                            icon: item.icon || "el-icon-search",
                            disabled: item.disabled,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.clickHandle(item, _vm.sonFormData)
                            },
                          },
                        },
                        [_vm._v(_vm._s(item.title || "查询") + "\n      ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  item.editer === "add"
                    ? _c(
                        "el-button",
                        {
                          style: item.style,
                          attrs: {
                            title: item.tooltip,
                            type: item.type || "primary",
                            size: item.size || "mini",
                            icon: item.icon || "el-icon-plus",
                            plain: item.plain === false ? false : true,
                            round: item.round,
                            circle: item.circle,
                            disabled: item.disabled,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.clickHandle(item, _vm.sonFormData)
                            },
                          },
                        },
                        [_vm._v(_vm._s(item.title || "新增") + "\n      ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  item.editer === "button"
                    ? _c(
                        "el-button",
                        {
                          style: item.style,
                          attrs: {
                            title: item.tooltip,
                            type: item.type,
                            icon: item.icon,
                            size: "mini",
                            plain: item.plain,
                            round: item.round,
                            circle: item.circle,
                            disabled: item.disabled,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.clickHandle(item, _vm.sonFormData)
                            },
                          },
                        },
                        [
                          item.title
                            ? _c("span", [_vm._v(_vm._s(item.title))])
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              )
            : item.editer === "cascader"
            ? _c(
                "el-form-item",
                {
                  key: index + item.value,
                  style: item.formItemStyle,
                  attrs: { label: item.label, prop: item.value },
                },
                [
                  _c("el-cascader", {
                    style: item.style,
                    attrs: {
                      options: item.options,
                      size: item.size || "mini",
                      clearable: item.clearable || true,
                      disabled: item.disabled || false,
                      separator: item.separator,
                      props: item.props,
                      filterable: item.filterable || false,
                      "show-all-levels": item.showAllLevels,
                      placeholder: item.placeholder,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.handleEvent(item)
                      },
                    },
                    model: {
                      value: _vm.sonFormData[item.value],
                      callback: function ($$v) {
                        _vm.$set(_vm.sonFormData, item.value, $$v)
                      },
                      expression: "sonFormData[item.value]",
                    },
                  }),
                ],
                1
              )
            : item.editer === "treeSelect" && !item.autoShow
            ? _c(
                "el-form-item",
                {
                  key: index + item.value,
                  style: item.formItemStyle,
                  attrs: { label: item.label, prop: item.value },
                },
                [
                  _c("dg-tree-select", {
                    style: item.style,
                    attrs: {
                      clearable: item.clearable,
                      size: item.size || "mini",
                      disabled: item.disabled,
                      value: _vm.sonFormData[item.value],
                      options: item.options,
                      "multiple-flag": item.multipleFlag,
                      props: item.props,
                      accordion: item.accordion,
                    },
                    on: {
                      getValue: function (value, name) {
                        return _vm.getTreeSelectValue(value, name, item)
                      },
                    },
                  }),
                ],
                1
              )
            : item.editer === "apiSelect"
            ? _c(
                "el-form-item",
                {
                  key: index + item.value,
                  style: item.formItemStyle,
                  attrs: { label: item.label, prop: item.value },
                },
                [
                  _c("dg-api-select", {
                    directives: [
                      {
                        name: "cleaveEl",
                        rawName: "v-cleaveEl",
                        value: item.cleave || { notCleave: true },
                        expression: "item.cleave || { notCleave: true }",
                      },
                    ],
                    attrs: {
                      value: _vm.sonFormData[item.value],
                      size: item.size || "mini",
                      maxlength: item.maxlength,
                      autosize: {
                        minRows: item.minRows,
                        maxRows: item.maxRows,
                      },
                      prefixIcon: item.prefixIcon,
                      suffixIcon: item.suffixIcon,
                      DgStyle: item.style,
                      readonly: item.readonly,
                      placeholder:
                        item.placeholder || (item.disabled ? "" : "请输入"),
                      disabled: item.disabled,
                      prepend: item.prepend,
                      append: item.append,
                    },
                    on: {
                      updateValue: function (value) {
                        _vm.updateValue(value, item)
                      },
                      input: function (value) {
                        _vm.handleEventInput(value, item)
                      },
                    },
                  }),
                ],
                1
              )
            : item.editer === "dimSelect"
            ? _c(
                "el-form-item",
                {
                  key: index + item.value,
                  style: item.formItemStyle,
                  attrs: { label: item.label, prop: item.value },
                },
                [
                  _c("dg-dim-select", {
                    directives: [
                      {
                        name: "cleaveEl",
                        rawName: "v-cleaveEl",
                        value: item.cleave || { notCleave: true },
                        expression: "item.cleave || { notCleave: true }",
                      },
                    ],
                    attrs: {
                      value: _vm.sonFormData[item.value],
                      size: item.size || "mini",
                      maxlength: item.maxlength,
                      autosize: {
                        minRows: item.minRows,
                        maxRows: item.maxRows,
                      },
                      prefixIcon: item.prefixIcon,
                      suffixIcon: item.suffixIcon,
                      DgStyle: item.style,
                      readonly: item.readonly,
                      placeholder:
                        item.placeholder || (item.disabled ? "" : "请输入"),
                      disabled: item.disabled,
                      prepend: item.prepend,
                      append: item.append,
                    },
                    on: {
                      updateValue: function (value) {
                        _vm.updateValue(value, item)
                      },
                      input: function (value) {
                        _vm.handleEventInput(value, item)
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]
      }),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }